const draftKey = (chatId: string) => `chat-draft-${chatId}`

export function readChatDraft(chatId: string | null): string {
  if (!chatId) return ''
  try {
    return sessionStorage.getItem(draftKey(chatId)) ?? ''
  } catch {
    return ''
  }
}

export function writeChatDraft(chatId: string | null, text: string): void {
  if (!chatId) return
  try {
    if (text) sessionStorage.setItem(draftKey(chatId), text)
    else sessionStorage.removeItem(draftKey(chatId))
  } catch {
    return
  }
}
